<!--
  ~ Copyright (C) 2023 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->
<mat-card class="upcoming-event__container" [class.disabled]="isDisabled" (click)="isDisabled ? false : redirectToEvent()">
  <div class="upcoming-event__image-box">
    <img
      #eventBoxImage
      class="event-box-image"
      alt="Event box image"
      (load)="loadImg()"
      [style.object-fit]="isPortraitImage ? 'contain' : 'fill'"
      [src]="event && event.imageUrl ? event.imageUrl : '/assets/card-placeholders/card-placeholder-' + ((index % 4) + 1) + '.png'"
    />
  </div>
  <div class="upcoming-event__content-box">
    <div class="upcoming-event__content-box-headline-date-location">
      <div class="event-headline medium bold">
        {{ getHeadline() }}
      </div>
      @if (dateDescription) {
        <div class="event-date">
          <svg class="svg" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.calendar' | transloco">
            <use ogSvgUnify="assets/sprite/sprite.svg#calendar"></use>
          </svg>
          <span class="small">{{ dateDescription }}</span>
        </div>
      }
      @if (locationDescription) {
        <div class="event-location">
          <svg class="svg" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.location' | transloco">
            <use ogSvgUnify="assets/sprite/sprite.svg#location"></use>
          </svg>
          <span class="medium">{{ locationDescription }}</span>
        </div>
      }
    </div>

    <div class="upcoming-event__content-box-organization-logo-tickets-left-participation">
      <div>
        <div class="organization-logo">
          <img class="organization-logo-image" alt="Logo" [src]="event ? event.organizationLogoUrl : ''" />
        </div>
      </div>

      @if (isDisabled) {
        <div class="participation-status">
          @if (event?.status?.type === 'UNPUBLISHED') {
            <div class="participation-status-content">
              <svg class="svg greyed" role="img" aria-hidden="true">
                <use ogSvgUnify="assets/sprite/sprite.svg#unpublish"></use>
              </svg>
              <span class="small">{{ 'translations.upcomingEventsV2.unpublished' | transloco }}</span>
            </div>
          } @else {
            <div class="participation-status-content">
              <svg class="svg greyed" role="img" aria-hidden="true">
                <use ogSvgUnify="assets/sprite/sprite.svg#lock"></use>
              </svg>
              <span class="small">{{ 'translations.upcomingEventsV2.prerequisitesNotCompleted' | transloco }}</span>
            </div>
          }
        </div>
      } @else {
        @if (event && (event.participationStatus === 'NONE' || !event.participationStatus)) {
          @switch (ticketsLeftLabel) {
            @case ('ALMOST_FULL') {
              <div class="tickets-left-label-box">
                <span class="tickets-left-label small almost-full">
                  {{ 'translations.upcomingEventsV2.almostFull' | transloco }}
                </span>
              </div>
            }
            @case ('FULL') {
              <div class="tickets-left-label-box">
                <span class="tickets-left-label small full">
                  {{ 'translations.upcomingEventsV2.full' | transloco }}
                </span>
              </div>
            }
          }
        }
        @if (
          event &&
          (event.participationStatus === 'WAITLISTED' ||
            event.participationStatus === 'REGISTERED' ||
            event.participationStatus === 'PARTICIPATED')
        ) {
          <div class="participation-status">
            @switch (event.participationStatus) {
              @case ('WAITLISTED') {
                <div class="participation-status-content">
                  <svg class="svg greyed" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.loading' | transloco">
                    <use ogSvgUnify="assets/sprite/sprite.svg#time-loading"></use>
                  </svg>
                  <span class="small">{{ 'translations.upcomingEventsV2.onTheWaitingList' | transloco }}</span>
                </div>
              }
              @case ('REGISTERED') {
                <div class="participation-status-content">
                  <svg class="svg positive" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.check' | transloco">
                    <use ogSvgUnify="assets/sprite/sprite.svg#check"></use>
                  </svg>
                  <span class="small">{{ 'translations.upcomingEventsV2.imGoing' | transloco }}</span>
                </div>
              }
              @case ('PARTICIPATED') {
                <div class="participation-status-content">
                  <svg class="svg positive" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.check' | transloco">
                    <use ogSvgUnify="assets/sprite/sprite.svg#check"></use>
                  </svg>
                  <span class="small">{{ 'translations.upcomingEventsV2.attended' | transloco }}</span>
                </div>
              }
            }
          </div>
        }
      }
    </div>
  </div>
</mat-card>
